import axios from 'axios';
import get from 'lodash/get';
import { integrations as integrationsCatalog } from '../../libs/statusCatalog';

import { thunkHandler, thunkErrorHanlder } from '../../libs/utils';

import {
  INTEGRATION,
  SAT_INTEGRATION,
  DOWNLOAD_INVOICES,
  SPEI_INTEGRATION,
  SAT_INTEGRATION_ERRORS,
} from '../../constants/endpoints';

export const NEW_INTEGRATION_SAT_DATA = 'NEW_INTEGRATION_SAT_DATA';
export const NEW_INTEGRATION_SAT_DOWNLOADS = 'NEW_INTEGRATION_SAT_DOWNLOADS';
export const NEW_INTEGRATION_SAT_ERRORS = 'NEW_INTEGRATION_SAT_ERRORS';
export const NEW_SPEI_DATA = 'NEW_SPEI_DATA';
export const NEW_INTEGRATIONS_STATE = 'NEW_INTEGRATIONS_STATE';
export const UPDATE_INTEGRATION = 'UPDATE_INTEGRATION';

export function integrateDownloads(body) {
  return dispatch => axios.post(DOWNLOAD_INVOICES, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DOWNLOADS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function updateDownloadIntegration(body) {
  return dispatch => axios.put(DOWNLOAD_INVOICES, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DOWNLOADS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function deleteDownloadIntegration() {
  return dispatch => axios.delete(DOWNLOAD_INVOICES)
    .then(() => dispatch({ type: NEW_INTEGRATION_SAT_DOWNLOADS, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getIntegrationsStates() {
  function parseIntegrationsStates(data) {
    const states = { states: data };
    data.forEach(integration => {
      const { integration_id } = integration;
      const integrationMeta = integrationsCatalog.getIntegration(integration_id);
      states[integrationMeta.name] = integration;
    });
    return states;
  }

  return dispatch => axios.get(INTEGRATION)
    .then(res => thunkHandler(dispatch, parseIntegrationsStates(get(res, 'data.data', [])), NEW_INTEGRATIONS_STATE, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getIntegrationSat() {
  return dispatch => axios.get(SAT_INTEGRATION)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function integrateSat(body) {
  return dispatch => axios.post(SAT_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function updateIntegrationSat(body) {
  return dispatch => axios.put(SAT_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function deleteIntegrationSat() {
  return dispatch => axios.delete(SAT_INTEGRATION)
    .then(() => dispatch({ type: NEW_INTEGRATION_SAT_DATA, payload: null }))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getSatIntegrationsErrors() {
  return dispatch => axios.get(SAT_INTEGRATION_ERRORS)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_INTEGRATION_SAT_ERRORS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getSpeiData() {
  return dispatch => axios.get(SPEI_INTEGRATION)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SPEI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function integrateSpei(body) {
  const options = { headers: { 'content-type': 'application/json' } };
  return dispatch => axios.post(SPEI_INTEGRATION, body, options)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SPEI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function updateSpeiData(body) {
  return dispatch => axios.put(SPEI_INTEGRATION, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SPEI_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function deleteSpeiIntegration() {
  return dispatch => axios.delete(SPEI_INTEGRATION)
    .then(() => getSpeiData())
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function manualUpdateIntegration(integration, newAttributes) {
  return dispatch => Promise.resolve(dispatch({
    type: UPDATE_INTEGRATION,
    payload: { integration, newAttributes }
  }));
}



// WEBPACK FOOTER //
// ./src/redux/actions/integrationsActions.js